import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/functions'

// firebase init - add your own config here
const firebaseConfig = {
	apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.VUE_APP_FIREBASE_APP_ID,
}
let initialzed = false
if (!initialzed) {
	firebase.initializeApp(firebaseConfig)
	initialzed = true
}

// utils
export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = firebase.functions()
// if(process.env.NODE_ENV === 'development'){
// 	functions.useEmulator('localhost', 5001)
// }
export const messaging : firebase.messaging.Messaging | undefined = firebase.messaging.isSupported()
? firebase.messaging()
: undefined

